import { render, staticRenderFns } from "./Ged.vue?vue&type=template&id=7befd0c8"
import script from "./Ged.vue?vue&type=script&lang=js"
export * from "./Ged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports